@if (open()) {
  <div class="ui-modal" (click)="onBackdrop()">
    <div
      class="ui-modal__dialog ui-modal__dialog--{{ size() }}"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="title() || 'Boîte de dialogue'"
      (click)="$event.stopPropagation()"
    >
      <header class="ui-modal__header">
        @if (title()) {
          <h3 class="ui-modal__title">{{ title() }}</h3>
        }
        <button
          type="button"
          class="ui-modal__close"
          (click)="close.emit()"
          aria-label="Fermer"
        >
          ✕
        </button>
      </header>

      <div class="ui-modal__body"><ng-content /></div>

      <ng-content select="[modal-footer]" />
    </div>
  </div>
}
